export const PROVIDER_COVER_GENIUS = 'cover_genius';
export const PROVIDER_NIB = 'nib';
export const CUSTOM_AMOUNT_COVERAGE_MULTIPLIER = 1.7;
// After this date, XCover doesn't use the multiplier anymore
export const COVERAGE_MULTIPLIER_LIMIT_DATE = '2025-06-10T23:59:59.999Z';
